import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
    applicationId: 'af8eef25-de3c-4ecb-9db1-172ff4b618be',
    clientToken: 'pub7021c0975fc1c7941ae51af19aba43e4',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'customer-portal-1',
    env: window.location.hostname,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
});
